import { Injectable } from "@angular/core";
import { SecurityGroup, SsoGroup } from "@data/security";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";
import { Observable } from "rxjs";

const API_URL = API.API_URL;

@Injectable()
export class SecurityGroupsService {
	private _securityAPIBase = `${API_URL}/security`;
	//private _groupsAPIBase = `${this._securityAPIBase}/groups`;
	//private _permissionsAPIBase = `${this._securityAPIBase}/permissions`;
	//private _ssoGroupAPIBase = `${this._securityAPIBase}/sso`;
	public _ssoGroups: SsoGroup[] = [];

	constructor(private httpManager: HttpManager) {}

	convertGroupToJSON(groupIn: SecurityGroup): {
		name: string;
		groupID: number;
		ssoID: number;
		ssoLabel: string;
		permissions: { permissionID: number; permission: string; permissionRemoved: boolean }[];
	} {
		const group = {
			name: groupIn.GroupLabel,
			groupID: groupIn.groupID,
			ssoID: groupIn.ssoID,
			ssoLabel: groupIn.ssoLabel,

			permissions: groupIn.permissions.map(permiss => {
				return {
					permissionID: permiss.PermissionID,
					permission: permiss.PermissionLabel,
					permissionRemoved: permiss.RemovedValue
				};
			})
		};

		return group;
	}

	//Security GROUP API CALLS
	getGroups(): Observable<SecurityGroup[]> {
		return this.httpManager.httpGet<SecurityGroup[]>(`${this._securityAPIBase}/groups`);
	}

	public getGroup(id: number): Observable<SecurityGroup> {
		return this.httpManager.httpGet<SecurityGroup>(`${this._securityAPIBase}/groups/${id}`);
	}

	public addGroup(groupIn: SecurityGroup): Observable<any> {
		return this.httpManager.httpPost<any>(`${this._securityAPIBase}/groups/add`, this.convertGroupToJSON(groupIn));
	}

	public updateGroup(groupIn: SecurityGroup): Observable<any> {
		return this.httpManager.httpPost<any>(
			`${this._securityAPIBase}/groups/${groupIn.groupID}/update`,
			this.convertGroupToJSON(groupIn)
		);
	}

	public deleteGroup(id: number): Observable<any> {
		return this.httpManager.httpGet<any>(`${this._securityAPIBase}/groups/${id}/delete`);
	}
}
